import _implicitStylesheets from "./icon.css";
import _implicitScopedStylesheets from "./icon.scoped.css?scoped=true";
import _appxProductIcons from "appx/productIcons";
import _appxBootstrapperIcons from "appx/bootstrapperIcons";
import _appxUtilityIcons from "appx/utilityIcons";
import _lightningIcon from "lightning/icon";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span${"c0"}${2}><svg${"c1"} xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52"${2}><path d="M26,2C12.8,2,2,12.8,2,26s10.8,24,24,24,24-10.8,24-24S39.2,2,26,2Zm19.04,21.6h-6.32c-.24-5.68-1.52-10.64-3.44-14.4,5.28,2.96,8.96,8.24,9.76,14.4ZM23.6,7.84v15.76h-5.52c.4-7.52,2.8-13.44,5.52-15.76Zm0,20.56v15.76c-2.72-2.32-5.12-8.24-5.52-15.76,0,0,5.52,0,5.52,0Zm4.8,15.76v-15.76h5.52c-.4,7.52-2.8,13.44-5.52,15.76Zm0-20.56V7.84c2.72,2.32,5.12,8.24,5.52,15.76h-5.52Zm-11.68-14.4c-1.92,3.76-3.12,8.72-3.44,14.4H6.96c.8-6.16,4.48-11.44,9.76-14.4ZM6.96,28.4h6.32c.24,5.68,1.52,10.64,3.44,14.4-5.28-2.96-8.96-8.24-9.76-14.4Zm28.32,14.4c1.92-3.76,3.12-8.72,3.44-14.4h6.32c-.8,6.16-4.48,11.44-9.76,14.4Z" fill="#fff"${3}/></svg></span>`;
const $fragment2 = parseFragment`<span class="text-icon${0}"${2}>${"t1"}</span>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, ncls: api_normalize_class_name, sp: api_static_part, st: api_static_fragment, d: api_dynamic_text} = $api;
  return [$cmp.isProductType ? api_custom_element("appx-product-icons", _appxProductIcons, {
    props: {
      "type": $cmp._icon,
      "alternativeText": $cmp._icon
    },
    key: 0
  }) : null, $cmp.isBootstrapperType ? api_custom_element("appx-bootstrapper-icons", _appxBootstrapperIcons, {
    props: {
      "type": $cmp._icon,
      "alternativeText": $cmp._icon
    },
    key: 1
  }) : null, $cmp.isCustomUtilityType ? api_custom_element("appx-utility-icons", _appxUtilityIcons, {
    props: {
      "type": $cmp._icon,
      "alternativeText": $cmp._icon
    },
    key: 2
  }) : null, $cmp.isIconLibType ? !$cmp.isUtilityHttp ? api_custom_element("lightning-icon", _lightningIcon, {
    className: api_normalize_class_name($cmp.iconClass),
    props: {
      "iconName": $cmp.iconName,
      "size": $cmp.size,
      "alternativeText": $cmp.iconDescription
    },
    key: 3
  }) : null : null, $cmp.isIconLibType ? $cmp.isUtilityHttp ? api_static_fragment($fragment1, 5, [api_static_part(0, {
    className: api_normalize_class_name($cmp.classesWithIconStyleForUtilityIcon)
  }, null), api_static_part(1, {
    className: api_normalize_class_name($cmp.classesWithSizeForUtilityIcon)
  }, null)]) : null : null, $cmp.isIconTextType ? api_static_fragment($fragment2, 7, [api_static_part(1, null, api_dynamic_text($cmp._icon))]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1c78lfu43eo";
tmpl.legacyStylesheetToken = "c360-icon_icon";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
